import React, { useState } from 'react';
import Dashboardnavbarcopy from '../../layout/Dashboardnavbarcopy';
import usePermission from '../../config/permissions';
import { ProjectClient, ProjectDetailTable, ProjectType } from './ProjectDetailsTable';



const ProjectDetailsManagement = () => {
    const { SUPER_ADMIN, PERMISSION_AUTHORITY } = usePermission(); // Use the custom hook

    const [toggleState, setToggleState] = useState(1);
    const getSelectedTitle = () => {
        switch (toggleState) {
            case 1:
                return 'Project Details';
            case 2:
                return 'Project Type';
            case 3:
                return 'Client Type';
            default:
                return 'Project Details Management';
        }
    };

    return (
        <>
            <Dashboardnavbarcopy name={getSelectedTitle()} url="Project Details Management" />
            {/* {PERMISSION_AUTHORITY ? */}
            <div className="bloc-tabss2  wfm-margin">
                <button
                    className={toggleState === 1 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                    onClick={() => setToggleState(1)}
                >
                    Project Details
                </button>
                < button
                    className={toggleState === 2 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                    onClick={() => setToggleState(2)}
                >
                    Project Type
                </button>
                < button
                    className={toggleState === 3 ? "dashboardcomponent-tabs  font-weight400  font-size-subheading    dashboardcomponent-active-tabs" : "dashboardcomponent-tabs  font-weight400  font-size-subheading   "}
                    onClick={() => setToggleState(3)}
                >
                    Client Type
                </button>

            </div>
            {/* : null
            } */}
            <div>
                {toggleState === 1 ? <ProjectDetailTable /> : null}
                {toggleState === 2 ? <ProjectType /> : null}
                {toggleState === 3 ? <ProjectClient /> : null}

            </div>
        </>
    );
};

export default ProjectDetailsManagement;